export enum Flow {
    UNAUTHORIZED = "unauthorized",
    NO_DATA_PLAN_AVAILABLE = "no_data_plan_available",
    COMPANION_SIMCARD_CHANGE = "companion_sim_card_change",
    NON_PAIRED_PLAN_FOUND = "non_paired_plan_found",
    NON_PAIRED_PLAN_FOUND_ON_OTHER_ACCOUNT = "non_paired_plan_found_on_other_account",
    MAX_DEVICE_PAIRING_LIMIT_REACHED = "max_device_pairing_limit_reached",
    START_NEW_COMPANION_PLAN = "start_new_companion_plan",
    SINGLE_DEVICE_PAIRED = "single_device_paired",
    MULTIPLE_DEVICES_PAIRED = "multiple_devices_paired",
    PENDING_CHANGE = "pending_change",
}
